import { ngxLoadingAnimationTypes } from "ngx-loading";
import { customConfig } from "../custom/custom-config";
import { buildConfig } from "../custom/build-config";
import { RoutingStrategyExclusionmode } from "./services/system/systemRoutingStrategyController";
import { Moment } from "moment";
import Utils from "./shared/utils";

const coreConfig = {
  /** Version of app */
  // version: "1.0.0", it will be set by customConfig (by build from app_version.json or params)
  /** App created at Date (It will be filling by buildConfig with the Date of getted Data from YourApp Server 'get_server_data.ts') */
  created_at_ymd: 20190101,
  /** App created at Time (It will be filling by buildConfig with the Date of getted Data from YourApp Server 'get_server_data.ts') */
  created_at_hms: 0,
  /** App created at DateTime */
  created_at: (): Moment => {
    return Utils.GetMomentFromInt(appConfig.created_at_ymd, appConfig.created_at_hms);
  },

  /** Update */
  update: {
    /** activate the automaticly chekung for new updates, by resume the app  */
    automatic: true,
    /** checks automaticly, by resume the app  */
    interval: 720 // all 12 hours
  },

  /** Check after x Minutes for new Data, by resume the app */
  sync_interval: 60, // evry hour

  /** Routing */
  routing: {
    routeCacheValidDuration: 1800, // Gültigkeit von gecachten Routen in Sekunden
    exclusionmode: RoutingStrategyExclusionmode.whitelist // Auschlussmodus 0 - Blacklist , 1 - Whitelist
  },

  /** Loader
   * ngx-loading: https://www.npmjs.com/package/ngx-loading
   */
  ngxLoading: {
    animationType: ngxLoadingAnimationTypes.pulse,
    backdropBackgroundColour: "rgba(255,255,255,1)",
    backdropBorderRadius: "4px",
    primaryColour: "#83b021",
    secondaryColour: "#000000",
    tertiaryColour: "#000000",
    fullScreenBackdrop: true
  },

  /** Touchsupport
   * hammer.js https://hammerjs.github.io/getting-started/
   */
  hammerjs: {
    touchAction: "pan-x pan-y"
  },

  /**
   * This is first cinfig for Swiper slider
   * it Initails the Swiper for first time as default
   * it can be change and overrive by changing Swiper Config in each Component
   */
  defualSwiperConfig: {
    direction: "horizontal",
    slidesPerView: "auto"
  },

  /** Brightness configs */
  brightness: {
    qr_code: 0.85 // display brightness if show qr-code
  }
};

/** Properties of the appConfig */
export const appConfig = { ...coreConfig, ...customConfig, ...buildConfig /* buildConfig wird durch die get_server_data.ts erzeugt */ };
